// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"df7d9a19","user":"e0dd5815","topRow":"f82fa4ad","name":"c4f2ffc9","email":"f5b157df","isAdmin":"d15a8447","userActive":"c9a01296"};